import { t } from '@hefe/i18n';
import { Modal, Typography } from 'antd';

interface GenerateEventReportWizardPrivacyComponentProps {
  modalOpen: boolean;
  closeModal: () => void;
}

export default function GenerateEventReportWizardPrivacyComponent(
  props: GenerateEventReportWizardPrivacyComponentProps
) {
  return (
    <Modal
      zIndex={999999}
      open={props.modalOpen}
      onCancel={props.closeModal}
      footer={null}
      bodyProps={{
        style: { padding: 20 },
      }}
    >
      <Typography.Paragraph>
        {t('game_reports.generate.privacy.description')}
      </Typography.Paragraph>
      <Typography.Paragraph>
        {t('game_reports.generate.privacy.data_transfer')}
      </Typography.Paragraph>
      <Typography.Paragraph>
        {t('game_reports.generate.privacy.consent')}
      </Typography.Paragraph>
      <Typography.Paragraph>
        {t('game_reports.generate.privacy.data_transfer_info')}
      </Typography.Paragraph>
      <Typography.Paragraph>
        {t('game_reports.generate.privacy.voluntary')}
      </Typography.Paragraph>
      <Typography.Paragraph>
        {t('game_reports.generate.privacy.more_info')}
      </Typography.Paragraph>
    </Modal>
  );
}
